import React from "react";
import Suppliers from "../../../Features/Tables/Suppliers";

const All = () => {
  return (
    <div>
      <Suppliers />
    </div>
  );
};

export default All;
